angular.module('iw.frontyard.common')
    .directive('iwInputAutoSize', function ($document) {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ctrl) {

                switch (element[0].nodeName) {
                    case 'INPUT':
                        setAutosizeForInput();
                        break;
                    case 'TEXTAREA':
                        setAutosizeForTextarea();
                        break;
                }

                function setAutosizeForTextarea() {
                    var update = function () {
                        element.css('height', 'auto');
                        element.css('height', element[0].scrollHeight + 'px');
                    };

                    scope.$watch(attributes.ngModel, function () {
                        update();
                    });

                    attributes.$set('ngTrim', 'false');
                }

                function setAutosizeForInput() {
                    var placeholder, span, resize;

                    placeholder = element.attr('placeholder') || '';

                    span = angular.element('<span></span>');
                    span[0].style.cssText = getComputedStyle(element[0]).cssText;
                    span.css('display', 'none')
                        .css('visibility', 'hidden')
                        .css('width', 'auto');

                    $document.find('body').append(span);

                    resize = function (value) {
                        if (angular.isDefined(value)) {
                            if (value.length < placeholder.length) {
                                value = placeholder;
                            }

                            span.text(value);
                            span.css('display', '');
                            try {
                                element.css('width', span.prop('offsetWidth') + 'px');
                            }
                            finally {
                                span.css('display', 'none');
                            }
                        } else {
                            element.css('width', '');
                        }
                    };

                    ctrl.$parsers.unshift(function (value) {
                        resize(value);
                        return value;
                    });

                    ctrl.$formatters.unshift(function (value) {
                        resize(value);
                        return value;
                    });
                }
            }
        };
    });